import useMediaQuery from "../hooks/useMediaQuery";
import { motion } from "framer-motion";
import AnchorLink from "react-anchor-link-smooth-scroll";
import profilePicture from "./../assets/profilePic.jpg";
import SocialMediaIcons from "./SocialMediaIcons";

const Landing = ({ setSelectedPage }) => {
	const isAboveLarge = useMediaQuery("(min-width: 1060px)");
	return (
		<section
			id="home"
			className="md:flex md:justify-between md:items-center gap-16 md:h-full py-10"
		>
			{/* IMAGE SECTION */}
			<div className="basis-3/5 z-10 mt-16 md:mt-32 flex justify-center md:order-2 relative group">
				{isAboveLarge ? (
					<motion.div
						className="relative z-0 ml-20 before:absolute before:-top-20 before:-left-20 before:rounded-t-[400px]
							before:w-full before:max-w-[400px] md:before:max-w-[600px] before:h-full before:border-2 before:border-blue before:z-[-1] before:group-hover:border-purple-400"
						initial="hidden"
						whileInView="visible"
						viewport={{ once: true, amount: 0.5 }}
						transition={{ duration: 0.5 }}
						variants={{
							hidden: { opacity: 0, y: -50 },
							visible: { opacity: 1, y: 0 },
						}}
					>
						<img
							src={profilePicture}
							alt="profile"
							className="hover:filter hover:saturate-100 transition duration-500 z-10 w-full max-w-[350px] md:max-w-[550px] rounded-tr-full rounded-tl-full"
						/>
					</motion.div>
				) : (

					<motion.div
						initial="hidden"
						whileInView="visible"
						viewport={{ once: true, amount: 0.5 }}
						transition={{ duration: 0.5 }}
						variants={{
							hidden: { opacity: 0, y: -50 },
							visible: { opacity: 1, y: 0 },
						}}
					>
					<img
						src={profilePicture}
						alt="profile"
						className="z-10 w-full max-w-[400px] md:max-w-[550px]"
					/>
					</motion.div>
				)}
			</div>

			{/* MAIN TEXT */}
			<div className="z-30 basis-2/5 mt-12 md:mt-32">
				{/* HEADINGS */}
				<motion.div
					initial="hidden"
					whileInView="visible"
					viewport={{ once: true, amount: 0.5 }}
					transition={{ duration: 0.5 }}
					variants={{
						hidden: { opacity: 0, x: -50 },
						visible: { opacity: 1, x: 0 },
					}}
					style={{ maxWidth: "500px" }}
					className=""
				>
					<p className="text-6xl font-playfair z-10 text-center md:text-start">
						José
						<span
							className="xs:relative xs:text-deep-blue xs:font-semibold z-20 xs:before:content-brush
              before:absolute before:-left-[25px] before:-top-[70px] before:z-[-1]"
						>
							Diogo
						</span>
					</p>

					<p className=" mt-12 mb-7 text-sm text-center md:text-start">
						Hi, my name is José. I'm a software developer based in Portugal.{" "}
						<br />
						I'm trying to learn as much as I can about web development <br />{" "}
						and I'm currently looking for a job.
					</p>
				</motion.div>

				{/* CALL TO ACTIONS */}
				<motion.div
					className="flex mt-5 justify-center md:justify-start gap-5"
					initial="hidden"
					whileInView="visible"
					viewport={{ once: true, amount: 0.5 }}
					transition={{ delay: 0.2, duration: 0.5 }}
					variants={{
						hidden: { opacity: 0, x: -50 },
						visible: { opacity: 1, x: 0 },
					}}
				>
					<AnchorLink
						className="border-t-2 border-b-2 hover:border-red rounded-sm py-3 px-7 font-semibold
               hover:text-white transition duration-500"
						onClick={() => setSelectedPage("projects")}
						href="#projects"
					>
						<div className="hover:text-blue transition duration-500">
							Projects
						</div>
					</AnchorLink>
					<AnchorLink
						className="hover:border-red border-t-2 border-b-2 py-0.5"
						onClick={() => setSelectedPage("contact")}
						href="#contact"
					>
						<div className="hover:text-blue transition duration-500 w-full h-full flex items-center justify-center px-10 font-playfair">
							Let's talk.
						</div>
					</AnchorLink>
				</motion.div>

				<motion.div
					className="flex mt-5 justify-center md:justify-start"
					initial="hidden"
					whileInView="visible"
					viewport={{ once: true, amount: 0.5 }}
					transition={{ delay: 0.4, duration: 0.5 }}
					variants={{
						hidden: { opacity: 0, x: -50 },
						visible: { opacity: 1, x: 0 },
					}}
				>
					<SocialMediaIcons />
				</motion.div>
			</div>
		</section>
	);
};

export default Landing;
